import React, { } from 'react';

import {
    Card,
    Checkbox,
    InputField,
    Dropdown
} from '@bosch/bt-ui';

import './CompanySettingsFields.css';
import withErrorHandler from '../../../components/ErrorHandler';


const CompanySettingsFields = (props) => {
    const {
        formValues,
        updateFormValues,
        mnvoValues,
        updateMnvoValues,
        companyInfo,
        updateCompanyInfoValues,
        companyMobileAlertSettings,
        updatecompanyMobileAlertValues,
        mode,
        emailErrorMsg,
        setEmailErrorMsg
    } = props;

    const region = [
        { label: 'United States', value: 'us' },
        { label: 'Canada', value: 'ca' }
    ];
    const language = [
        { label: 'US English', value: 'en-US' },
        { label: 'French(Canada)', value: 'fr-CA' } 
    ];

    const deviceRegionOptions = JSON.parse(sessionStorage.getItem('deviceRegionOptions'));
    if (mode === 'add' || mode === 'reservation')
    {
        if (companyInfo.deviceRegion == null || companyInfo.deviceRegion === '')
            companyInfo.deviceRegion = deviceRegionOptions[0].label
    }

    return (
        <Card
            htmlAttributes={{
                id: 'company-Settings',
                className: 'firmware-overview-section'
            }}
        >
            <div className="caption font-large">Company Settings</div>
            <div className="company-input-field">
                <InputField
                    inputType="text"
                    fieldName="companyName"
                    label="Company Name"
                    htmlAttributes={{
                        onChange: updateCompanyInfoValues,
                        value: companyInfo.companyName,
                        disabled: (mode === 'add') ? false : ((mode === 'update') ? false : true)
                    }}
                />
                <InputField
                    inputType="text"
                    fieldName="sapCompanyId"
                    label="SAP Company ID"
                    htmlAttributes={{
                        onChange: updateCompanyInfoValues,
                        value: companyInfo.sapCompanyId,
                        disabled: (mode === 'add') ? false : ((mode === 'update') ? true : true)
                    }}
                />
                <Dropdown
                    fieldName="sapSalesRegion"
                    label="SAP Sales Region"
                    options={region}
                    htmlAttributes={{
                        onChange: updateCompanyInfoValues,
                        value: companyInfo.sapSalesRegion,
                        disabled: (mode === 'add') ? false : ((mode === 'update') ? false : true)
                    }}
                />
                <Dropdown
                    fieldName="deviceRegion"
                    label="Device Region"
                    options={deviceRegionOptions}
                    htmlAttributes={{
                        onChange: updateCompanyInfoValues,
                        value: companyInfo.deviceRegion,
                        disabled: (mode === 'add' || mode === 'reservation') ? false : true
                    }}
                />
                
                <Checkbox
                    fieldName="servicePortalOnboarded"
                    label="Onboarded to Service Portal"
                    htmlAttributes={{
                        onChange: updateFormValues,
                        checked: formValues.servicePortalOnboarded ?? true
                    }}
                />
                <Checkbox
                    fieldName="makeRemotePortalReadOnly"
                    label={mode === 'update' ? 'Make Remote Portal Read-Only' : 'Make Remote Portal Read-Only On Creation Of Company'}
                    htmlAttributes={{
                        onChange: updateFormValues,
                        checked: formValues.makeRemotePortalReadOnly ?? true
                    }}
                />
                <Checkbox
                    fieldName="webconnectMobileEnabled"
                    label="Enable Webconnect for Mobile connectivity"
                    htmlAttributes={{
                        onChange: updateFormValues,
                        checked: formValues.webconnectMobileEnabled ?? false
                    }}
                />
            </div>
            <div className="company-input-field">
                <div className="first">
                    <div className="font-medium">MVNO&apos;s in Use</div>
                    <div className="filter-checkboxes">
                        <Checkbox
                            fieldName="Aeris"
                            label="Aeris"
                            htmlAttributes={{
                                onChange: updateMnvoValues,
                                checked: mnvoValues['Aeris'] ?? false
                            }}
                        />

                        <Checkbox
                            fieldName="Wyless"
                            label="Wyless"
                            htmlAttributes={{
                                onChange: updateMnvoValues,
                                checked: mnvoValues['Wyless'] ?? false
                            }}
                        />

                        <Checkbox
                            fieldName="Verizon"
                            label="Verizon"
                            htmlAttributes={{
                                onChange: updateMnvoValues,
                                checked: mnvoValues['Verizon'] ?? false
                            }}
                        />

                    </div>
                </div>
                <div>
                    <div className="textblock">
                    <span>Email Address to receive Mobile Data Notifications:</span>
                    </div>
                    <div className="second">
                    
                    <InputField
                        inputType="text"
                        fieldName="usageAlertEmail"
                        label="Email Address"
						validationError={emailErrorMsg}
						onValidationError={(update) => {
							setEmailErrorMsg(update.value);
						}}
                        htmlAttributes={{
                            onChange: updatecompanyMobileAlertValues,
                            value: companyMobileAlertSettings.usageAlertEmail,
                            pattern: '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$',
							title: 'Email is invalid'
                        }}
                    />
                    
                    </div>
                    
                </div>
                <div>
                        <div className="third">
                        <Checkbox
                        fieldName="usageMonitoringEnabled"
                        label="Enable Notification"
                        htmlAttributes={{
                            onChange: updatecompanyMobileAlertValues,
                            checked: companyMobileAlertSettings.usageMonitoringEnabled ?? true
                        }}
                    />
                    <Dropdown
                        fieldName="preferredLanguage"
                        label="Notification Language"
                        options={language}
                        htmlAttributes={{
                            onChange: updatecompanyMobileAlertValues,
                            value: companyMobileAlertSettings.preferredLanguage,
                        }}
                    />
                        </div>
                </div>
            </div>

        </Card>
    );
};

export default withErrorHandler(React.memo(CompanySettingsFields));